module.exports = __webpack_public_path__ + "img/home-img-travel-2.f9494859.jpg";